var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mvm
    ? _c("div", { staticClass: "info" }, [
        _vm.dvm
          ? _c(
              "div",
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", [
                      _c("h2", [
                        _vm._v("機台編號：" + _vm._s(_vm.mvm.AssetNo)),
                      ]),
                      _c(
                        "h3",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mvm.client,
                              expression: "mvm.client",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "客戶名稱： " +
                              _vm._s(
                                _vm.mvm.client && _vm.mvm.client.customer_code
                              ) +
                              " " +
                              _vm._s(_vm.mvm.client && _vm.mvm.client.name)
                          ),
                        ]
                      ),
                      _c(
                        "h3",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.mvm.op_locate,
                              expression: "mvm.op_locate",
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "機台位置：" +
                              _vm._s(
                                _vm.mvm.op_locate &&
                                  _vm.mvm.op_locate.location_code
                              ) +
                              " " +
                              _vm._s(
                                _vm.mvm.op_locate &&
                                  _vm.mvm.op_locate.location_name
                              )
                          ),
                        ]
                      ),
                      _c("h3", [
                        _vm._v(
                          "發票是否啟用：" +
                            _vm._s(
                              _vm.mvm.invoice_settings.Invoice
                                ? "啟用"
                                : "不啟用"
                            )
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "發票啟用起始時間：" +
                            _vm._s(_vm.mvm.invoice_settings.EnableSince)
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "是否列印發票：" +
                            _vm._s(
                              _vm._f("printInvoiceFilter")(
                                _vm.dvm.setting.printInvoice
                              )
                            )
                        ),
                      ]),
                      _c("h3", [
                        _vm._v(
                          "是否列印明細：" +
                            _vm._s(
                              _vm._f("printDetailFilter")(
                                _vm.dvm.setting.printReceipt
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { staticClass: "gates" },
                      [
                        _c("h3", { staticClass: "gate-section-title" }, [
                          _vm._v("即時貨道"),
                        ]),
                        _c(
                          "el-row",
                          _vm._l(_vm.dvm.gates, function (gate, index) {
                            return _c(
                              "el-col",
                              { key: index, attrs: { lg: 6, sm: 12, xs: 24 } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gate-status",
                                    class: _vm._f("statusFilter")(gate),
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "gate-status-header" },
                                      [
                                        _c("div", [
                                          _c("h2", [
                                            _vm._v(
                                              "貨道 " + _vm._s(gate.GateNo)
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "hardware-gate-display",
                                            },
                                            [
                                              _vm._v(
                                                "硬體貨道 " +
                                                  _vm._s(
                                                    gate.HardwareGateNo ||
                                                      gate.GateNo
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _c(
                                          "span",
                                          { staticClass: "gate-status-badge" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("statusTextFilter")(gate)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "gate-product-name",
                                        attrs: {
                                          title: gate.Product.ProductNa,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            gate.Product.ProductNa ||
                                              "未設定商品"
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("div", { staticClass: "gate-metrics" }, [
                                      _c(
                                        "div",
                                        { staticClass: "gate-metric" },
                                        [
                                          _c("span", [_vm._v("售價")]),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                gate.Product.UnitPrice ||
                                                  gate.Price ||
                                                  0
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "gate-metric" },
                                        [
                                          _c("span", [_vm._v("庫存")]),
                                          _c("strong", [
                                            _vm._v(_vm._s(gate.Stock)),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "gate-metric" },
                                        [
                                          _c("span", [_vm._v("銷售")]),
                                          _c("strong", [
                                            _vm._v(_vm._s(gate.Sales)),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "gate-metric" },
                                        [
                                          _c("span", [_vm._v("缺補")]),
                                          _c("strong", [
                                            _vm._v(_vm._s(gate.Short)),
                                          ]),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c("el-col", [
                      _c("div", { staticClass: "hardware-gate-panel" }, [
                        _c("div", { staticClass: "hardware-gate-toolbar" }, [
                          _c("div", [
                            _c("h3", { staticClass: "hardware-gate-title" }, [
                              _vm._v("硬體貨道對照設定"),
                            ]),
                            _c(
                              "span",
                              { staticClass: "hardware-gate-summary" },
                              [
                                _vm._v(
                                  "已變更 " +
                                    _vm._s(_vm.dirtyHardwareGateRows.length) +
                                    " 筆"
                                ),
                              ]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "hardware-gate-actions" },
                            [
                              _c(
                                "div",
                                { staticClass: "sequence-field" },
                                [
                                  _c("span", [_vm._v("前綴文字")]),
                                  _c("el-input", {
                                    staticClass: "sequence-prefix",
                                    attrs: {
                                      size: "mini",
                                      placeholder: "無前綴",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.sequencePrefix,
                                      callback: function ($$v) {
                                        _vm.sequencePrefix = $$v
                                      },
                                      expression: "sequencePrefix",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sequence-field" },
                                [
                                  _c("span", [_vm._v("起始號碼")]),
                                  _c("el-input-number", {
                                    staticClass: "sequence-start",
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: 0,
                                    },
                                    model: {
                                      value: _vm.sequenceStart,
                                      callback: function ($$v) {
                                        _vm.sequenceStart = $$v
                                      },
                                      expression: "sequenceStart",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "sequence-field" },
                                [
                                  _c("span", [_vm._v("補零位數")]),
                                  _c("el-input-number", {
                                    staticClass: "sequence-pad",
                                    attrs: {
                                      size: "mini",
                                      "controls-position": "right",
                                      min: 0,
                                      max: 4,
                                    },
                                    model: {
                                      value: _vm.sequencePad,
                                      callback: function ($$v) {
                                        _vm.sequencePad = $$v
                                      },
                                      expression: "sequencePad",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("span", { staticClass: "sequence-preview" }, [
                                _vm._v("範例：" + _vm._s(_vm.sequencePreview)),
                              ]),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: { click: _vm.applySequence },
                                },
                                [_vm._v("依序套用")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      _vm.pasteDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("貼上對照表")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    disabled:
                                      _vm.dirtyHardwareGateRows.length === 0,
                                  },
                                  on: { click: _vm.resetHardwareGateRows },
                                },
                                [_vm._v("重設")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    loading: _vm.savingHardwareGates,
                                    disabled:
                                      _vm.dirtyHardwareGateRows.length === 0,
                                  },
                                  on: { click: _vm.saveHardwareGateRows },
                                },
                                [_vm._v("儲存全部")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "hardware-gate-grid" },
                          _vm._l(_vm.hardwareGateRows, function (row) {
                            return _c(
                              "div",
                              {
                                key: row.GateNo,
                                staticClass: "hardware-gate-row",
                                class: {
                                  dirty: _vm.isHardwareGateRowDirty(row),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "hardware-gate-row-main" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "hardware-gate-no" },
                                      [_vm._v("貨道 " + _vm._s(row.GateNo))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "hardware-gate-product",
                                        attrs: { title: row.ProductNa },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(row.ProductNa || "未設定商品")
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "hardware-gate-current" },
                                  [
                                    _c("span", [_vm._v("目前")]),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(row.OriginalHardwareGateNo)
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("el-input", {
                                  staticClass: "hardware-gate-edit-input",
                                  attrs: { size: "small" },
                                  model: {
                                    value: row.HardwareGateNo,
                                    callback: function ($$v) {
                                      _vm.$set(row, "HardwareGateNo", $$v)
                                    },
                                    expression: "row.HardwareGateNo",
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "貼上硬體貨道對照",
                      visible: _vm.pasteDialogVisible,
                      width: "520px",
                      "append-to-body": "",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.pasteDialogVisible = $event
                      },
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 10,
                        placeholder: "每行一筆：貨道\t硬體貨道，例如 1\tA1",
                      },
                      model: {
                        value: _vm.pasteText,
                        callback: function ($$v) {
                          _vm.pasteText = $$v
                        },
                        expression: "pasteText",
                      },
                    }),
                    _c(
                      "span",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.pasteDialogVisible = false
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.applyPasteText },
                          },
                          [_vm._v("套用")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }